import { type EditorConfig, ParagraphNode, type SerializedParagraphNode } from 'lexical';

export type SerializedLineHeightNode = SerializedParagraphNode & {
  style?: string;
};

export class LineHeightNode extends ParagraphNode {
  declare __style: string;

  constructor(key?: string) {
    super(key);
    this.__style = 'line-height:1.5';
  }

  static getType(): string {
    return 'styled-paragraph';
  }

  static clone(node: LineHeightNode): LineHeightNode {
    const newNode = new LineHeightNode(node.__key);
    newNode.__style = node.__style;
    return newNode;
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config);
    const style = this.getStyle();
    if (style) {
      dom.style.cssText = style;
    }
    return dom;
  }

  updateDOM(prevNode: ParagraphNode, dom: HTMLElement, config: EditorConfig): boolean {
    const didUpdate = super.updateDOM(prevNode, dom, config);
    if (prevNode instanceof LineHeightNode && this.__style !== prevNode.__style) {
      dom.style.cssText = this.__style || '';
    }
    return didUpdate;
  }

  getStyle(): string {
    const self = this.getLatest();
    return self.__style;
  }

  setStyle(style: string): this {
    const self = this.getWritable();
    self.__style = style;
    return self;
  }

  static importJSON(serializedNode: SerializedLineHeightNode): LineHeightNode {
    const node = new LineHeightNode();
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    node.setStyle(serializedNode.style || '');
    return node;
  }

  exportJSON(): SerializedLineHeightNode {
    return {
      ...super.exportJSON(),
      type: 'styled-paragraph',
      version: 1,
      style: this.getStyle() || '',
    };
  }
}

export function $createLineHeightNode(): LineHeightNode {
  return new LineHeightNode();
}

export function $isLineHeightNode(node: any): node is LineHeightNode {
  return node instanceof LineHeightNode;
}
